import { formatThousandsInt } from '../../../../../utils/format/formatThousands';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { BusinessStatisticItemProps } from './types';

export const BusinessStatisticItem = (props: BusinessStatisticItemProps) => {
    const { displayValue, diffValue, diffDisplay, title, isFirstValue, ...other } = props;
    const diff = diffValue ? (
        <Typography
            variant="caption"
            color={diffValue >= 0 ? 'var(--color-success)' : 'var(--color-danger)'}
        >
            {diffDisplay}
        </Typography>
    ) : null;
    const numValue = Number(displayValue);
    const value = (
        <Typography variant="body">
            {numValue ? formatThousandsInt(numValue) : displayValue}
        </Typography>
    );

    return (
        <Flex width="100%" direction="row" justifyContent="space-between" pt={2} {...other}>
            <Typography variant="body">{title}</Typography>
            <Flex direction="row" spacing={1} alignItems="baseline">
                {isFirstValue ? [value, diff] : [diff, value]}
            </Flex>
        </Flex>
    );
};
